export const WHATSAPP_URL = 'https://wa.me/2250554466100';
export const PHONE_DISPLAY = '+225 05 54 46 61 00';
export const EMAIL = 'contact@bitexpress.fun';
export const LOCATION = 'Abidjan, Côte d\'Ivoire';

export const openWhatsApp = () => window.open(WHATSAPP_URL, '_blank', 'noopener,noreferrer');

export const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) element.scrollIntoView({ behavior: 'smooth' });
};

export const NAV_ITEMS = [
  { id: 'home', key: 'home' },
  { id: 'services', key: 'services' },
  { id: 'about', key: 'about' },
  { id: 'how-it-works', key: 'process' },
  { id: 'request', key: 'request' },
  { id: 'contact', key: 'contact' }
];
